angular.module('impactx.catalog').controller('ReviewCatalogCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToolbarService',
    'BackService',
    'ToastService',
    'TranslationService',
    ReviewCatalogCtrl]);

function ReviewCatalogCtrl($scope, dataGen, $routeParams, ToolbarService, BackService, ToastService, TranslationService) {
    var ctrl = this;

    dataGen.getData($scope, {id: $routeParams.id}, "/catalog/review").then(function () {
        ctrl.initToolbarButtons();
    });

    this.initToolbarButtons = function () {
        $scope.buttonDefinition = [];
        ToolbarService.setButtons($scope.buttonDefinition);
    };

    this.sendRequest = function () {
        dataGen.postAsForm($scope, {reviewCatalog: $scope.data}, "/catalog/review/request").then(function () {
            BackService.back();
            ToastService.openStandardToast($scope.trns.sendSuccess);
        });
    };

}
